import { faAngleDown } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconButton, useTheme } from '@mui/material'
import { GridRenderCellParams } from '@mui/x-data-grid'

type AdditionalServiceDetailPanelToggleProps = Pick<GridRenderCellParams, 'id' | 'value'>

export function AdditionalServiceDetailPanelToggle(props: AdditionalServiceDetailPanelToggleProps) {
  const { value: isExpanded } = props
  const theme = useTheme()

  return (
    <>
      <IconButton size="small" tabIndex={-1} sx={{ width: 32, height: 32 }}>
        <FontAwesomeIcon
          color={theme.palette.secondary.main}
          icon={faAngleDown}
          style={{
            fontSize: "0.875rem",
            transform: `rotateZ(${isExpanded ? 180 : 0}deg)`,
          }}
        />
      </IconButton>
    </>
  )
}
